import { Loader } from '@/ui/loaders/loader/Loader'
import type { ReactNode } from 'react'
import InfiniteScrollComponent from 'react-infinite-scroll-component' // eslint-disable-line no-restricted-imports

type InfiniteScrollProps = {
  dataLength: number
  next: () => void
  hasMore: boolean
  children: ReactNode
  className?: string
  endMessage?: ReactNode
}

export function InfiniteScroll({
  dataLength,
  next,
  hasMore,
  children,
  className,
  endMessage,
}: InfiniteScrollProps) {
  return (
    <InfiniteScrollComponent
      dataLength={dataLength}
      next={next}
      hasMore={hasMore}
      className={className}
      endMessage={endMessage}
      loader={
        <div className="flex items-center justify-center p-2 text-primary">
          <Loader size="2xl" />
        </div>
      }
    >
      {children}
    </InfiniteScrollComponent>
  )
}
